/**
 * @desc 工具方法
 * @time 2023-07-31 16:11:05
 * @user simxin
 */

import { APP_MODE } from '@src/config/index';

/**
 * @desc 去除前后#
 * @before /trtc/state#hash
 * @after /trtc/state
 */
export const stripHash = function (url: string) {
  return url.replace(/^#+|#.*$/g, '');
};

/**
 * @desc 去除前后斜杠
 * @before /trtc/state/
 * @after trtc/state
 */
export const stripSlash = function (url: string) {
  return url.replace(/^\/+|\/+$/g, '');
};

/**
 * @desc 去除路由前后?
 * @before /trtc/state?id=1
 * @after /trtc/state
 */
export const stripQuestion = function (url: string) {
  return url.replace(/^\?+|\?.*$/g, '');
};

/**
 * @desc 清理路由字符串中多余的参数
 * @before /trtc/state?id=1#hash
 * @after trtc/state
 */
export const stripRoutePure = function (url: string) {
  return stripSlash(stripHash(stripQuestion(url)));
};

/**
 * @desc 当前应用是简易模式
 */
export const isSimpleAppMode = function () {
  return APP_MODE === 'simple';
};

export const isPreTest = function () {
  return (
    process.env.VITE_ENV_NODE_ENV === 'pre' ||
    process.env.VITE_ENV_NODE_ENV === 'test'
  );
};
